export default __webpack_public_path__ + "static/media/hackerEdu2.92543c58.png";